export const PUBLIC_ROUTE = {
    path: 'account',
    get url(): string {
        return `/${this.path}`;
    }
};

export const LAYOUT_ROUTE = {
    path: 'dashboard',
    get url(): string {
        return `/${this.path}`;
    }
};

export const BACKEND_VERIFICATION_TEMPLATE_ROUTE = {
  path: 'verification',
  get url(): string {
    return `/${this.path}`;
  }
}

export const PRIVACY_POLICIES_ROUTE ={
  path:'privacy_policy',
  get url():string{
    return `/${this.path}`
  }
}
export const TERM_AND_CONDITION_ROUTE = {
  path: 'term_conditions',
  get url(): string {
    return `/${this.path}`
  }
}

export const ABOUT_US_ROUTE = {
  path: 'about_us',
  get url(): string {
    return `/${this.path}`
  }
}

export const CONTACT_US_ROUTE = {
  path: 'contact_us',
  get url(): string {
    return `/${this.path}`
  }
}

export const APP_ROUTES_CONSTANTS = {
  PUBLIC_ROUTE,
  LAYOUT_ROUTE,
  BACKEND_VERIFICATION_TEMPLATE_ROUTE,
  PRIVACY_POLICIES_ROUTE,
  TERM_AND_CONDITION_ROUTE,
  ABOUT_US_ROUTE,
  CONTACT_US_ROUTE
}


